import React from 'react';
import {AuthedLayout} from 'components/Layout';

const ApproachLazy = React.lazy(() => import(/* webpackChunkName: "Approach" */ './Approach'));

export const Approach = props => <AuthedLayout component={ApproachLazy} {...props} />;
